import {ArtfactKind} from '@mrp-brasil/nick-data-commons';
import {BaseHook, Hook, HookClass, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import {Observable} from 'rxjs';
import {concatMap, map} from 'rxjs/operators';

@HookClass('cache')
export class CacheHook extends BaseHook {

    @Hook('3c0042cc-d5ed-4088-8b5b-6290938b0bf0')
    public invalidate(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.service('CacheService')
            .pipe(concatMap((service: any) => {
                return service.invalidate(inputArtifact.object.key, inputArtifact.object.systemId);
            })).pipe(map((result: any) => {
                const artifact = new NickProcessArtfact();
                artifact.object = result;
                artifact.kind = ArtfactKind.ANY;
                return artifact;
            }));
    }

    @Hook('17e5711d-68d9-4a3d-bcf6-e4d9b4ff32b7')
    public set(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.service('CacheService')
            .pipe(concatMap((service: any) => {
                return service.setCache(inputArtifact.object.key, inputArtifact.object.data, inputArtifact.object.expire);
            })).pipe(map((result: any) => {
                const artifact = new NickProcessArtfact();
                artifact.object = inputArtifact.object.data;
                artifact.kind = ArtfactKind.ANY;
                return artifact;
            }));
    }

    @Hook('cccd534a-e764-4519-88ac-5d968eb05879')
    public get(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.service('CacheService')
            .pipe(concatMap((service: any) => {
                return service.getCache(inputArtifact.object.key);
            })).pipe(map((result: any) => {
                const artifact = new NickProcessArtfact();
                artifact.object = result;

                if (result != null)
                    artifact.object = JSON.parse(result);

                artifact.kind = ArtfactKind.ANY;
                return artifact;
            }));
    }
}
